import {
  GET_PAYROLL,
  GET_PAYROLL_SUCCESS,
  GET_PAYROLL_FAIL,
  DELETE_PAYROLL,
  DELETE_PAYROLL_SUCCESS,
  DELETE_PAYROLL_FAIL,
  UPDATE_PAYROLL,
  UPDATE_PAYROLL_SUCCESS,
  UPDATE_PAYROLL_FAIL,
  ADD_NEW_PAYROLL,
  ADD_PAYROLL_SUCCESS,
  ADD_PAYROLL_FAIL,
  PAYROLL_LOADING,
} from "./actionType";

export const getPayrollSuccess = (actionType, data) => ({
  type: GET_PAYROLL_SUCCESS,
  payload: { actionType, data },
});

export const getPayrollFail = (actionType, error) => ({
  type: GET_PAYROLL_FAIL,
  payload: { actionType, error },
});

export const getPayroll = data => ({
  type: GET_PAYROLL,
  payload: data,
});

export const getPayrollLoading = () => ({
  type: PAYROLL_LOADING
});

export const deletePayroll = data => ({
  type: DELETE_PAYROLL,
  payload: data,
});

export const deletePayrollSuccess = data => ({
  type: DELETE_PAYROLL_SUCCESS,
  payload: data,
});

export const deletePayrollFail = error => ({
  type: DELETE_PAYROLL_FAIL,
  payload: error,
});

export const updatePayroll = data => ({
  type: UPDATE_PAYROLL,
  payload: data,
});

export const updatePayrollFail = error => ({
  type: UPDATE_PAYROLL_FAIL,
  payload: error,
});

export const updatePayrollSuccess = data => ({
  type: UPDATE_PAYROLL_SUCCESS,
  payload: data,
});

export const addNewPayroll = data => ({
  type: ADD_NEW_PAYROLL,
  payload: data,
});

export const addPayrollSuccess = data => ({
  type: ADD_PAYROLL_SUCCESS,
  payload: data,
});

export const addPayrollFail = error => ({
  type: ADD_PAYROLL_FAIL,
  payload: error,
});